<template>
  <div class="docs">
    <h6>Document links</h6>
    <transition-group name="list" tag="div">
      <document-card
        v-for="doc of docs_for_edit"
        :key="doc.id"
        :doc="doc"
        :onChange="onChange"
      />
    </transition-group>

    <div class="panel" v-if="addNewMode">
      <document-form
        :document="new_doc"
        :onSave="saveNewDoc"
        :refreshTrigger="newDocRefresh"
        :onClose="() => (addNewMode = false)"
        :onChange="onChange"
      />
    </div>

    <div class="plus-btn" @click="addDocument()" v-if="!addNewMode">
      <img src="~@/assets/icons/add.svg" />
      <span>Add new</span>
    </div>

    <div style="margin: 10px -10px; border-top: solid 1px #c6c6c6;" />

    <h6>Attachments</h6>

    <ProjectAttachments
      label="Choose a file or drag it here"
      :files="project.projectFiles || []"
      @fileAdded="Array.isArray(project.projectFiles) ? project.projectFiles.push($event) : project.projectFiles = [$event]"
      @removeFile="project.projectFiles = project.projectFiles.filter(file => file.id !== $event)"
    >
      <template v-slot:file-item="{file, viewFile, removeFile}">
        <div class="file panel">
          <div class="view">
            <b-spinner v-if="file.progress" :value="file.progress" style="margin-right: 10px;"></b-spinner>
            <a v-else class="icon"></a>
            <img class="go" src="~@/assets/icons/go.svg" />
            <div class="text">
              <div class="top">
                <h4>{{ file.filename }}</h4>
                <span>{{ file.updatedAt ? moment(file.updatedAt).format('DD MMM YYYY, h:mma') : '' }}</span>
              </div>
              <div v-if="file.createdById &&  users[file.createdById]" class="bottom">
                <p>{{ `Uploaded by ${users[file.createdById].name}`}}</p>
<!--                <a @click="viewFile()" target="_blank">Click to download</a>-->
              </div>
            </div>

            <div class="actions">
              <img v-if="file.key" src="~@/assets/icons/download.svg" @click="viewFile()" />
              <img src="~@/assets/icons/trash_only.svg" @click="removeFile()" />
            </div>
          </div>
        </div>
      </template>

    </ProjectAttachments>
  </div>
</template>

<script>
import DocumentCard from './DocumentCard';
import DocumentForm from './DocumentForm';
import ProjectAttachments from "@/components/ProjectAttachments";
import moment from 'moment';
import {mapGetters} from "vuex";

export default {
  name: 'ProjectModal_Documents',
  props: {
    project: Object,
    onChange: Function,
  },
  data() {
    return {
      new_doc: {
        id: -1,
        title: '',
        description: '',
        type: null,
        url: '',
        projectId: this.project.id,
      },
      newDocRefresh: 0,
      addNewMode: false,
      moment
    };
  },
  methods: {
    saveNewDoc(newDoc) {
      this.new_doc.id--;
      this.$store.dispatch('setDocForEdit', newDoc);
      this.newDocRefresh++;
      this.addNewMode = false;

      if (this.onChange) {
        this.onChange();
      }
    },
    addDocument() {
      this.addNewMode = true;
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
  },
  computed: {
    ...mapGetters(['users']),
    project_id() {
      return this.$store.getters.project_modal_id;
    },
    all_documents() {
      return this.$store.getters.documents;
    },
    project_documents() {
      if (!this.project || !this.project.projectDocuments) return [];
      return this.project.projectDocuments.map(doc => {
        return {
          url: doc.url,
          title: doc.title,
          description: doc.description,
          type: doc.type,
          id: doc.id,
          updatedAt: doc.updatedAt,
          projectId: doc.projectId,
        };
      });
    },
    docs_for_edit() {
      return this.$store.getters.docs_for_edit || [];
    },
  },
  components: {
    ProjectAttachments,
    'document-card': DocumentCard,
    'document-form': DocumentForm,
  },
  watch: {
    project_documents() {
      this.$store.dispatch('setDocsForEdit', this.project_documents);

      // if (!this.project_documents.length) {
      //   this.addNewMode = true;
      // } else {
      //   this.addNewMode = false;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.docs {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;

  .panel {
    margin-bottom: 12px;
    padding: 16px 18px;
  }
}

.list-item {
  display: inline-block;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.4s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
}


.file.panel {
  margin-bottom: 12px;
  padding: 16px 18px;
  transition: all 0.4s;
  position: relative;

  > .view {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
  }

  &:hover {
    box-shadow: 0 0 14px 2px rgba(41, 42, 44, 0.09);

    //.text .bottom {
    //  p {
    //    display: none;
    //  }
    //
    //  a {
    //    display: inline-block;
    //  }
    //}

    //.go {
    //  opacity: 1;
    //}

    .actions {
      display: block;
    }
  }

  .icon {
    width: 48px;
    height: 48px;
    background-repeat: no-repeat;
    background-size: 336px 96px;
    background-image: url(~@/assets/icons/documents.svg);
    background-position: top left -240px;
    margin-right: 10px;
  }

  .go {
    position: absolute;
    top: 50px;
    left: 49px;
    z-index: 1;
    opacity: 0;
    pointer-events: none;
  }

  .text {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    max-width: 480px;

    .top {
      min-width: 100%;

      h4 {
        display: inline-block;
        margin: 0;
        font-size: 14px;
        font-weight: 500;
        color: #26292f;
        margin-right: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 330px;
        white-space: nowrap;
        position: relative;
        top: 3px;
      }

      span {
        font-size: 13px;
        font-weight: 400;
        color: #acb6c1;
      }
    }

    .bottom {
      p,
      a {
        font-size: 14px;
        font-weight: 400;
        color: #26292f;
        margin: 0;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 480px;
        white-space: nowrap;
        position: relative;
        top: 2px;
      }

      a {
        display: none;
        color: #acb6c1;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .actions {
    position: absolute;
    right: 25px;
    top: 18px;
    display: none;

    img {
      cursor: pointer;
      margin-left: 15px;

      &:first-child {
        margin-left: 0px;
      }
    }
  }
}
</style>
